import { FC } from 'react';
import { StockExchange } from '../components/StockExchange';
interface StockDealProps {}

export const StockDeal: FC<StockDealProps> = () => {
  return <StockExchange />;
};
